import React from 'react'
import DatesTable from './components/DateTable/DatesTable'
import Title from '../../../components/Title/Title'
import { importantDates2024 } from '../../../common/constants/importantDates'

const ImportantDates2024page = () => {
  return (
    <>
      <Title>Important Dates</Title>
      <DatesTable array={importantDates2024} />
    </>
  )
}

export default ImportantDates2024page;
